import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import {Globals} from '.././globals';
@Injectable()
export class FollowerService {

  user:any;
  constructor(private http: HttpClient,private _global:Globals) {
  
  }
  readonly rootUrl = this._global.siteUrl;


  myStudentFollower(Obj){
    return this.http.post(this.rootUrl + 'follower/myStudentFollower', Obj);  
  }

  myTeacherFollower(Obj){
    return this.http.post(this.rootUrl + 'follower/myTeacherFollower', Obj);  
  }
  follow(Obj){
    return this.http.post(this.rootUrl + 'follower/follow', Obj);  
  }


}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/follower.service.ts